<template>
  <section class="trial-of-great-red-dragon-s-offspring" v-parallax>
    <v-page :background="theme.colors.cyan" v-slide-up-in>
      <v-sub-chapter-index-page
        :pageData="pageDataItem.page0.data"
        v-slide-up-in-stage="1"
      />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        paintPath="images/six-trials-of-God-s-judgment-work/trial-of-great-red-dragon-s-offspring/page1ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page1.data"
      />
    </v-page>

    <v-page>
      <v-text-content
        :isGodsWord="true"
        :html="pageDataItem.page2.data.content"
      />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-float-image-content :data="pageDataItem.page3.data.content" />
    </v-page>

    <v-page>
      <v-text-content
        :isGodsWord="true"
        :html="pageDataItem.page4.data.content"
      />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-float-image-content :data="pageDataItem.page5.data.content" />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-float-image-content :data="pageDataItem.page6.data.content" />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-text-content :html="pageDataItem.page7.data.content" />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        paintPath="images/six-trials-of-God-s-judgment-work/trial-of-great-red-dragon-s-offspring/page5ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page8.data"
      />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <satan-logical-laws-fallacies :data="pageDataItem.page9.data" />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-full-screen-songs-player
        :data="pageDataItem.page10.data"
        bg="images/common/hymnsPosters/six-trials-of-God-s-judgment-work-6.jpg"
      />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-chatper-entry />
    </v-page>
  </section>
</template>

<script>
import { mapState } from "vuex";
import satanLogicalLawsFallacies from "./components/satan-logical-laws-fallacies/index";

export default {
  components: {
    satanLogicalLawsFallacies,
  },
  computed: {
    ...mapState("global", ["schema"]),
  },
  data() {
    return {
      pageDataItem: {},
    };
  },
  created() {
    this.pageDataItem = this.schema[
      "trial-of-great-red-dragon-s-offspring"
    ].item;
  },
};
</script>
